import React from 'react';
import CircleInfoIcon from '@square-icons/react/16/UI/circle-info';
import { Box } from '@mui/material';
import { BASE_THEME } from 'theme/shop_theme';
import { BANNER_TYPE } from 'components/common/banners/banner_helpers';
import { STICKY_HEADER_OFFSET } from 'components/pages/product/helpers';

export const STICKY_BANNER_ID = 'sticky-banner';
const CTA_SUBNAV_CLASSNAME = 'CtaSubnav';

/*
  bannerType: BANNER_TYPE Type from banner_helpers
  component: any text element like p / div / i18n Trans / etc
*/
const StickyBanner = ({ bannerType = BANNER_TYPE.info, component = null }) => {
  let backgroundColor = null;
  let icon = null;
  const ctaSubNavExists =
    document.getElementsByClassName(CTA_SUBNAV_CLASSNAME).length > 0;

  switch (bannerType) {
    case BANNER_TYPE.info: {
      backgroundColor = '#E6F0FF';
      icon = (
        <CircleInfoIcon
          style={{
            paddingRight: '6px',
            fill: BASE_THEME.color.blue,
            verticalAlign: 'text-top',
          }}
        />
      );
      break;
    }
    default: {
      return <></>;
    }
  }

  return (
    <Box
      data-testid={STICKY_BANNER_ID}
      className={'StickyBanner'}
      sx={{
        position: 'sticky',
        backgroundColor,
        top: ctaSubNavExists ? `${STICKY_HEADER_OFFSET}px` : 0,
        left: 0,
        right: 0,
        paddingLeft: '10%',
        paddingRight: '10%',
        py: 2,
        textAlign: 'center',
        boxShadow: '0px 3px 4px -3px rgba(0,0,0,0.50)',
        zIndex: 1,
        lineHeight: BASE_THEME.type.lineHeight.base,
      }}
    >
      {icon}
      {component}
    </Box>
  );
};

export default StickyBanner;
